import { ReactNode } from 'react';

import { Icon } from '@iconify/react';

import './AnswerStatus.scss';

interface AnswerStatusProps {
  isCorrect: boolean;
  titleText?: string;
  className?: string;
  children?: ReactNode;
}

export default function AnswerStatus({ isCorrect, className, titleText, children }: AnswerStatusProps) {
  return (
    <div className={`answer-status ${isCorrect ? 'correct' : 'incorrect'} ${className}`}>
      <Icon icon="material-symbols:done" className="icon" />
      {titleText && <p className="title-text">{titleText}</p>}
      <div className="children">{children}</div>
    </div>
  );
}
